import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    business: [],
    lastQuery: null,
};

const getters = {
    business(state) {
        return state.business;
    },
};

const mutations = {
    setBusiness(state, data) {
        state.business = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    getBusinessListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.business.length || state.lastQuery != params.query) {
            return dispatch('getBusiness', params);
        }

        return Promise.resolve(state.business);
    },

    getBusiness({ commit, dispatch }, params) {
        let route = Laroute.route('admin.business');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'business_loading');

        return axios
            .get(route, options)
            .then(res => {
                commit('setBusiness', res.data.data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'business_loading');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'business_loading');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/business.js